








import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class Heading2 extends Vue {
  @Prop() private title_no?: number;
}
